import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54361524"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-main text-white rounded-xl flex-col justify-between position-desktop absolute hidden md:flex" }
const _hoisted_2 = { class: "flex flex-col pt-2 pb-6 pl-6 pr-6 gap-2" }
const _hoisted_3 = { class: "text-secondary text-center text-xl" }
const _hoisted_4 = { class: "flex flex-row gap-4" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white text-5xl font-black" }, [
  /*#__PURE__*/_createElementVNode("span", { id: "statsNbOperations" })
], -1))
const _hoisted_7 = { class: "text-white text-l font-black" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white text-5xl font-black" }, [
  /*#__PURE__*/_createElementVNode("span", { id: "statsNbPeopleAssisted" })
], -1))
const _hoisted_10 = { class: "text-white text-l font-black" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("stats.since")) + " 2016", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("stats.rescueNb")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("stats.peoples")), 1)
        ]),
        _hoisted_11
      ])
    ])
  ]))
}